<div class="games-footer-wrapper">

  <div class="footer-row">

    <div class="currency">
      <span class="number">{{ saldoCliente | currency:'EUR'}}</span>
      <span class="label">Tu Saldo</span>
    </div>

    <div class="separator"></div>

    <div class="currency">
      <span class="number">{{ cost + (guinda && !manual ? guindaCost : 0) | currency:'EUR' }}</span>
      <span class="label">Apuesta</span>
    </div>

    @if (donacion) {
      <div class="separator"></div>
    }

    @if (donacion) {
      <div class="donation-wrapper">
        <div class="cost">
          <span>{{ (donacion * betNumbers) | currency:'EUR' }}</span>
          @if (donacion >= 0) {
            <img class="icon"
              matTooltip="Cada décimo tendrá un recargo de {{ donacion | number: '.2-2'}}€ como donativo . {{empresa.info_donacion}}"
              matTooltipTouchGestures="on"
              src="/assets/images/icons/balance/icono info.png" />
          }
        </div>
        <span class="cost-text" [innerHTML]="donacion >= 0 ? 'Donación' : 'Descuento'"></span>
      </div>
    }
    <div class="toRight">
      <button (click)="playBet()" [disabled]='disabled' [ngClass]="disabled ? 'disabled-button' : activeClass"
        [matTooltip]="empresa && empresa.compra_minima > 0 && disabled ? 'Compra mínima ' + empresa.compra_minima + ' numeros': ''">
        @if (!loading) {
          {{titlebutton}}
        }

        @if (loading) {
          <mat-spinner [diameter]="30"></mat-spinner>
        }
      </button>
    </div>


  </div>

</div>